export const tr = {
    'choose-goal': 'Hedef seçin',
    'involved-sessions': 'Hedefe yönelik oturumlar',
    'less-then-min-conversion': 'Dönüşüm değeri en az {minConversion}{currencySymbol} olabilir',
    'more-then-max-conversion': 'Belirtilen dönüşüm değeri çok yüksek',
    'not-chosen-goal': 'Hedef seçilmedi',
    'unavailable-goal': 'Hedef bulunamadı'
};
